/* eslint camelcase: 0 */
import { Area } from '@/infrastructure/network/Monitaro/schema/models'
import { IAreaProps, EmptyAreaPropsFactory } from '@/entities/Area'

export const toAreaProps = (props: Area | null | undefined): IAreaProps => {
  if (!props) {
    return EmptyAreaPropsFactory()
  }

  const { id, name, zeacon, hospital_id, properties, flags, created_at, updated_at } = props

  return EmptyAreaPropsFactory({
    id,
    name,
    zeacon,
    hospitalId: hospital_id,
    properties,
    flags,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
